// extracted by mini-css-extract-plugin
export default {"ctaButton":"Button2_ctaButton__9QdFC"};